import { Table } from '@consta/uikit/Table'
import type { ProjectWellVsp } from '@core/core/types'
import type { FC } from 'react'
import { useState } from 'react'

import type { OnApplyVspFunc, OnSwitchActiveVspFunc } from '../../types'
import { getVspTableColumns, transformWellVspToRows } from './helpers'

type VspTableProps = {
  wellVsp?: ProjectWellVsp
  actionLabel: string
  onApplyVsp: OnApplyVspFunc
  onSetActiveProjectVsp?: OnSwitchActiveVspFunc
}

export const VspTable: FC<VspTableProps> = ({
  wellVsp,
  actionLabel,
  onApplyVsp,
  onSetActiveProjectVsp,
}) => {
  const [hoveredRowId, setHoveredRowId] = useState<string>()

  const rows = transformWellVspToRows(wellVsp)

  return (
    <Table
      columns={getVspTableColumns(hoveredRowId, actionLabel, onApplyVsp, onSetActiveProjectVsp)}
      rows={rows}
      size="s"
      verticalAlign="center"
      stickyHeader={true}
      lazyLoad={{ maxVisibleRows: 100, scrollableEl: window }}
      onRowHover={({ id }) => {
        setHoveredRowId(id)
      }}
    />
  )
}
